import Jt808BatchAddSengcmdModal from './jt808-batch-add-sendcmd-modal.vue'
export default Jt808BatchAddSengcmdModal
